(function () {
    'use strict';
    var controllerId = 'attachAdd2';
    angular.module('app').controller(controllerId, ['$scope', 'datacontext', 'sectionMenu', '$uibModalInstance', 'FileUploader', '_', 'tSource', 'tSourceCode', 'tSourceId', 'source', 'sourceId', 'tAttach', 'tAttachId', attachAdd2]);

    function attachAdd2($scope, datacontext, sectionMenu, $uibModalInstance, FileUploader, _, tSource, tSourceCode, tSourceId, source, sourceId, tAttach, tAttachId) {
        $scope.attach = {};
        $scope.tAttach = tAttach;
        $scope.tSource = tSource;
        $scope.source = source;
        $scope.maxKB_Def = 40960;
        $scope.bTitleChanged = false;
        $scope.upload_URL = datacontext.upload_getURL();
        $scope.attach.uploaded = false;
        $scope.bInsert = false;
        $scope.acceptFileTypes = 'application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/x-rtf, application/rtf, text/richtext, .rtf, application/x-pkcs7-mime, application/pkcs7-mime';
        $scope.msgFilesExt = '';
        $scope.myTAttach = {};

        //Impostazioni per calendario dateTimePicker
        $scope.datepickers = {};
        $scope.today = function () {
            $scope.dt = new Date();
        };
        $scope.today();

        // Disable weekend selection
        $scope.disabled = function (date, mode) {
            return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
        };

        $scope.toggleMin = function () {
            $scope.minDate = $scope.minDate ? null : new Date();
        };
        $scope.toggleMin();
        $scope.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        $scope.openCalendar = function ($event, iOpened) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened1 = false;
            if (iOpened == 1)
                $scope.opened1 = true;
        };

        $scope.clear = function ($event, iOpened) {
            if (iOpened == 1) {
                $scope.attach.Date1 = '';
                $scope.changed = true;
            }
        };

        if (tSourceId) {
            $scope.tSourceId = tSourceId;
            $scope.attach.TSourceId = tSourceId;
            $scope.attach.TSourceName = $scope.tSource[0].Name;
        }

        if (tSourceCode) {
            $scope.tSourceCode = tSourceCode;
            $scope.attach.TSourceName = $scope.tSource[0].Name;
            if (!source) {
                getListSource(tSourceCode);
            }
        }

        if (typeof ($scope.attach.TSourceName) == 'undefined') {
            $scope.attach.TSourceName = 'Riferimento';
        }

        if (sourceId) {
            $scope.sourceId = sourceId;
            $scope.attach.SourceId = sourceId;
        }

        if (tAttachId) {

            $scope.tAttachId = tAttachId;
            $scope.attach.TAttachId = tAttachId;
            $scope.myTAttach = _.find($scope.tAttach, { 'Id': tAttachId });

            if (typeof $scope.myTAttach != 'undefined') {
                $scope.tAttachName = $scope.myTAttach.Name;
                setTAttachParams($scope.myTAttach);

                if ($scope.myTAttach.iBit1 > 0)
                    $scope.myTAttach.checkBit1 = 0;
            }

            

            //console.info('$scope.myTAttach', $scope.myTAttach);
        }
        else {
            //se tAttach non � definito carico solo quelli non ancora presenti a sistema
            getTAttach(tSourceCode, sourceId, $scope.attach.TAttachId);
        }

        //Gestione Bit1: SI o NO
        $scope.checkBit1_click = function () {
            if (typeof $scope.myTAttach != 'undefined') {
                switch ($scope.myTAttach.checkBit1) {
                    case 1: //SI
                        $scope.attach.Bit1 = true;
                        break;
                    case 2: //NO
                        $scope.attach.Bit1 = false;
                        break;
                }
            }
        }


        function setTAttachParams(myTAttach) {
            //1) Definisco se si hanno le autorizzazioni per inserire
            //$scope.bInsert = myTAttach.bInsert;
            //2) Definisco i tipi di file ammessi
            setMaxKB(myTAttach.MaxKB);
            //3) Definisco la dimensione massima consentita
            setListFileTypes(myTAttach.FileType);
            //console.info('$scope.bInsert', $scope.bInsert);
        }

        function setListFileTypes(fileTypes) {
            var str = '';
            var arrExt = [];

            //Inizializzo la variabile msgFilesExt
            $scope.msgFilesExt = '';

            if ($.isNumeric(fileTypes))
                return;

            fileTypes.forEach(function (item) {
                str += item.Title + ', ';
                arrExt.push(item.Extension);
            });

            var arrExtAfter = _.map(
                _.uniq(
                    _.map(arrExt, function (obj) {
                        return JSON.stringify(obj);
                    })
                ), function (obj) {
                    return JSON.parse(obj);
                }
            );

            var strExt = arrExtAfter.join(", ");

            //Remove last comma and white space
            str = str.replace(/,\s*$/, "");
            strExt = strExt.replace(/,\s*$/, "");

            if (str.length > 0) {
                $scope.acceptFileTypes = str;
            }

            if (strExt.length > 0) {
                $scope.msgFilesExt = strExt;
            }

            return $scope.acceptFileTypes;
        }



        function setMaxKB(MaxKB) {
            $scope.maxKB = MaxKB == 0 ? $scope.maxKB_Def : MaxKB;

            if ($scope.maxKB >= 1024)
                $scope.MaxDim = parseInt(($scope.maxKB / 1024)) + ' MB';
            else if ($scope.maxKB < 1024)
                $scope.MaxDim = parseInt(($scope.maxKB)) + ' KB';

            //console.info('maxKB', item, $scope.maxKB);
            return $scope.maxKB;
        }

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = addItem($scope.attach)
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return datacontext.attach_add(item).then(function (data) {
                //console.info('addItem', data);
                return data;
            });
        }

        $scope.TSourceChanged = function () {
            //console.log('TSourceChanged');
            var tSourceId = $scope.attach.TSourceId;
            $scope.source = [];
            $scope.attach.SourceId = 0;
            $scope.tAttach = [];
            $scope.attach.TAttachId = 0;
            return datacontext.tSource_get(tSourceId).then(function (data) {
                $scope.tSourceCode = data.Code;
                getListSource(data.Code);
                return true;
            });
        };

        $scope.SourceChanged = function () {
            $scope.tAttach = [];
            $scope.attach.TAttachId = 0;
            getTAttach($scope.tSourceCode, $scope.attach.SourceId);

            return false;
        };

        function getTAttach(tSourceCode, sourceId, tAttachId) {
            var onlyMissing = 1;
            if ($scope.tAttach == null)
                $scope.tAttach = [];

            //return datacontext.tAttach_getAllList(tSourceCode, 0, sourceId, onlyMissing, tAttachId).then(function (data) {
            return datacontext.tAttach_getAllModal(tSourceCode, 0, sourceId, onlyMissing, tAttachId).then(function (data) {
                var listTA = data;

                return datacontext.tAttachVisibility_getAuth(tSourceCode).then(function (data) {

                    var tAttach_auth = data;
                    tAttach_auth.forEach(function (item_TAV) {

                        var myrec = _.find(listTA, { 'Id': item_TAV.TAttachId });
                        //console.info('myrec-prima', myrec);

                        if (typeof (myrec) != 'undefined') {

                            myrec.bRead = item_TAV.bRead;
                            myrec.bInsert = item_TAV.bInsert;
                            myrec.bUpdate = item_TAV.bUpdate;
                            myrec.bDelete = item_TAV.bDelete;
                            myrec.iTags = item_TAV.iTags;
                            if (myrec.bRead)
                                $scope.tAttach.push(myrec);
                            //console.info('myrec', myrec);
                        }
                    });

                    //console.info('tAttach', $scope.tAttach, listTA);
                    return $scope.tAttach;
                });               
            });
        }

        /*
        $scope.getBInsert = function (tAttachId) {
            if (!tAttachId) return;

            return $scope.tAttach.forEach(function (item_TA) {
                if (item_TA.Id == tAttachId)
                    $scope.bInsert = item_TA.bInsert;
            });

            //console.info('getBInsert', $scope.tAttach, $scope.bInsert);
            return $scope.bInsert;
        }

        
        function getTAttach(tSourceCode, sourceId, tAttachId) {
        	var onlyMissing = 1;
            return datacontext.tAttach_getAllList(tSourceCode, 0, sourceId, onlyMissing, tAttachId).then(function (data) {
        		return $scope.tAttach = data;
        	});
        }
        */

        function getListSource(tSourceCode) {
            return datacontext.source_getAllList(tSourceCode).then(function (data) {
                return $scope.source = data;
            });
        }

        $scope.TitleChanged = function () {
            $scope.bTitleChanged = true;
            return false;
        }

        $scope.removeFile = function (item) {
            $scope.attach.Path = '';
            $scope.attach.Name = '';
            $scope.attach.KB = 0;
            $('#inputFile').val("");

            $scope.attach.uploaded = false;
            return false;
        }



        // FILTERS
        var uploader = $scope.uploader = new FileUploader({
            url: $scope.upload_URL
        }
        );

        uploader.filters.push({
            name: 'customFilter',
            fn: function (item /*{File|FileLikeObject}*/, options) {
                return this.queue.length < 10;
            }
        });

        // CALLBACKS

        uploader.onWhenAddingFileFailed = function (item /*{File|FileLikeObject}*/, filter, options) {
            /*
        	//console.info('onWhenAddingFileFailed', item, filter, options);
        	console.log('onWhenAddingFileFailed - end');
            */
        };
        uploader.onAfterAddingFile = function (fileItem) {
            /*
        	//console.info('onAfterAddingFile', fileItem);
        	console.log('onAfterAddingFile - end');
        	console.dir(fileItem);
            */
        };
        uploader.onAfterAddingAll = function (addedFileItems) {
            /*
        	//console.info('onAfterAddingAll', addedFileItems);
        	console.log('onAfterAddingAll - end');
            */
        };
        uploader.onBeforeUploadItem = function (item) {
            /*
            //console.info('onBeforeUploadItem', item);
            console.log('onBeforeUploadItem');
            */
        };
        uploader.onProgressItem = function (fileItem, progress) {
            /*
            //console.info('onProgressItem', fileItem, progress);
        	console.log('onProgressItem - end');
        	console.dir(progress);
            */
        };
        uploader.onProgressAll = function (progress) {
            /*
        	//console.info('onProgressAll', progress);
        	console.log('onProgressAll - end');
            */
        };
        uploader.onSuccessItem = function (fileItem, response, status, headers) {
            //console.info('onSuccessItem', fileItem, response, status, headers);
            console.log('onSuccessItem - end');
            //console.dir(response);
            if (response != null && response.length > 0) {
                var data = response[0];
                $scope.attach.Path = data.PathServer;
                console.dir(data.PathServer);
                $scope.attach.Name = data.NameOrig;
                if ($scope.attach.Title == '' || $scope.attach.Title == null || typeof $scope.attach.Title == 'undefined') {
                    $scope.attach.Title = data.NameOrig;
                } 
                $scope.attach.KB = data.Length;
                $scope.attach.uploaded = true;
            }

        };
        uploader.onErrorItem = function (fileItem, response, status, headers) {
            /*
            //console.info('onErrorItem', fileItem, response, status, headers);
        	console.log('onErrorItem - end');
            */
        };
        uploader.onCancelItem = function (fileItem, response, status, headers) {
            /*
        	//console.info('onCancelItem', fileItem, response, status, headers);
        	console.log('onCancelItem - end');
            */
        };
        uploader.onCompleteItem = function (fileItem, response, status, headers) {
            /*
        	//console.info('onCompleteItem', fileItem, response, status, headers);
        	console.log('onCompleteItem - end');
            */
        };
        uploader.onCompleteAll = function () {
            /*
        	//console.info('onCompleteAll');
        	console.log('onCompleteAll - end');
            */
        };

        //console.info('uploader', uploader);

        // LOCALIZZAZIONE DOCUMENTAZIONE IN ORIGINALE
        $scope.loc_province = [];
        $scope.loc_comuni = [];
        $scope.loc_tIndirizzi = [];

        getTIndirizzi();
        getProvince();
        if ($scope.attach.Loc_ProvinciaId > 0) getComuni($scope.attach.Loc_ProvinciaId);

        function getTIndirizzi() {
            if ($scope.loc_tIndirizzi.length > 0) return;

            datacontext.arrTIndirizzo().then(function (data) {
                $scope.loc_tIndirizzi = jQuery.extend([], data);
            });
        }
        function getProvince() {
            if ($scope.loc_province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                $scope.loc_province = jQuery.extend([], data);
            });
        }
        function getComuni(idprov) {
            if (!idprov || idprov == 0) return $scope.loc_comuni = [];

            if ($scope.attach.Loc_ProvinciaId != idprov)
                $scope.loc_comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return $scope.loc_comuni = data;
            });
        }

        $scope.resetComuni = function (idprov) {
            $scope.attach.Loc_ComuneId = '';
            getComuni(idprov);
        };


    }
})();